import React,{useEffect,useState} from 'react';
import './sns-button.scss'
import useSnsInfoState from '../../../store/sns-info';
import useUserState from '../../../store/user';
import * as stringUtil from '../../../utils/string';
import Loading from '../../common/loading/loading';
import {request, unSubRequest} from '../../../utils/request';
import { toast } from 'react-toastify';

// action = "connect", "link"
const SnsButton = ({action, snsType, checkNeeded}) => {

  // Check if action is link
  // if it's link, check api to see linked status
  // if linked, change to button to unlinked
  // if not linked, keep the same.

  // on facebook-auth.js & google-auth.js add in code to check if a user is logged in.
  // if logged in, send to authRoute backend

  // on backend, 
    // normRoute endpoint
    // authRoute endpoint

  const {user} = useUserState();
  const {snsInfo} = useSnsInfoState();
  const [loading,setLoading] = useState(false);
  const [linkInfo,setLinkInfo] = useState(null);

  const text = (action === "link") ? "Link account with ": "Connect with ";
  let type = "unknown";
  let urlName = "";
  let url = "#";
  let disable = true;
  let hide = false;
  let failed = false;

  useEffect(() => {
    return () => {
      unSubRequest("get-sns-link-info-"+snsType);
    }
  },[snsType]);

  useEffect(() => {
    if(action === "link"){
      refreshSnsInfo(snsType);
    }
  },[action,snsType]);

  const refreshSnsInfo = (snsType) => {
    setLoading(true);
    request("get-sns-link-info-"+snsType,"/get-sns-link-info","GET", {}, {
      then: function(res){
        let info = null;
        if(snsType === "google"){
          info = res.data.res.google;
        }else if(snsType === "facebook"){
          info = res.data.res.facebook;
        }
        setLinkInfo(info);
      },
      catch: function(err){
        toast.error(err.message);
      },
      finally: function(){
        setLoading(false);
      }
    });
  }

  const unlinkAccount = (snsType,user) => {

    if(!user.passSet){
      toast.error("Please set a password before unlinking your SNS account. ");
      return false;
    }

    let url = "";
    if(snsType === "google"){
      url = "/google-link";
    }else if(snsType === "facebook"){
      url = "/facebook-link";
    }else{
      toast.error("Error, check console");
      console.error("couldn't recognize snsType",snsType);
      return false;
    }

    setLoading(true);
    request(url,url,"DELETE", {}, {
      then: function(res){
        toast.success("Success, unlinked your account!");
      },
      catch: function(err){
        toast.error(err.message);
      },
      finally: function(){
        setLoading(false);
        refreshSnsInfo(snsType);
      }
    });
  }

  if(snsType === "google"){
    type = snsType;
    urlName = "googleUrl";
  }else if(snsType === "facebook"){
    type = snsType;
    urlName = "facebookUrl";
  }else{
    console.error("SnsButton snsType not recognized: "+snsType);
    hide = true;
  }

  if(snsInfo !== null){
    if(snsInfo[urlName] !== undefined){
      url = snsInfo[urlName];
      disable = false;
    }else{
      failed = true;
    }
  }

  if(action === "link" && linkInfo === null && !loading){
    disable = true;
    failed = true;
  }

  if(hide){
    return (<div className="hide"></div>);
  }

  if(disable || loading){
    return( 
      <div className={"button sns-button "+type+"-button disabled"}>
        <a href={url} 
          onClick={(e) => {e.preventDefault()}}>
          {(failed) ? 
          "Failed to load "+stringUtil.capitalize(snsType)+" Resources":
          "Loading "+stringUtil.capitalize(snsType)+" Resources"}
          {(!failed)?<Loading show={true} size={"24px"} /> :""}
        </a>
      </div>
    )
  }

  if(action === "link" && linkInfo.linked){
    return(
      <div
        className={"button sns-button linked "+type+"-button"}
        onClick={() => {unlinkAccount(snsType,user);}}>
        <div>
          <span className="email">
            {linkInfo.email}
          </span>
          <span className="unlink">
            Unlink Account 
          </span>
        </div>
      </div>
    )
  }

  return (  
    <div className={"button sns-button "+type+"-button"}>
      <a href={url} onClick={(e)=>{
        if(checkNeeded){
          e.preventDefault();
          toast.error("Please confirm that you've reviewed the terms of use. ")
        }
      }}>
        {text+stringUtil.capitalize(snsType)}
      </a>
    </div>
  );

};

export default SnsButton;